import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef
} from "@angular/core";
import { GeneralService } from "./services/general.service";
import { Subscription } from "rxjs";
import { MerchantItems } from "./models/items";
import { CommunicationCommand } from "./models/communicationCommands";
import * as localForage from "localforage";
import { MockStoreService } from "./services/mock-store.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild("generalModalTrigger") generalModalTrigger: ElementRef;
  title = "merchantClanApp";
  slideOut: boolean = false;
  addItem: boolean = false;
  addCatalogue: boolean = false;
  catalogueInput: any;
  viewCatalogueInput: any;
  componentToDisplay: string = "view-content";
  itemsSelectedFromSelectionComponent: MerchantItems[] | any = [];
  // edit added Item
  itemToEdit: MerchantItems | boolean;
  // holds rxjs subscriptions for clean up operations
  destroySubscriptions: Array<Subscription> = [];

  constructor(
    private mockstore: MockStoreService,
    private generalservice: GeneralService
  ) {}

  ngOnInit() {
    this.destroySubscriptions[0] = this.generalservice.sidebarSwitcher$.subscribe(
      val => {
        // console.log(val, this.componentToDisplay);
        if (typeof val == "object") {
          // console.log(val);
          const { message, switcher, component } = val;
          if (switcher == "on") {
            this.slideOut = true;
            this.componentToDisplay = component;
            return;
          }
        }
        if (val instanceof CommunicationCommand) {
          const { action, message, component } = val;
          component == "settings"
            ? (this.componentToDisplay = component)
            : (this.componentToDisplay = "");
          this.slideOut = true;
          return;
        }
        if (val == "on") {
          this.slideOut = true;

          return;
        }
        this.slideOut = false;
      }
    );

    // this observable can trigger the view, add or edit views for the catalogue
    this.destroySubscriptions[1] = this.generalservice.addItem$.subscribe(
      val => {
        if (typeof val == "string" && val.trim() == "addItems") {
          //  hack starts here. This is just to make sure the addItem form removes all
          // previously held data;
          this.itemToEdit = false;
          // ends here
          this.addItem = true;
          this.addCatalogue = false;
          (this.generalModalTrigger.nativeElement as HTMLButtonElement).click();
        }
        if (typeof val == "string" && val.trim() == "addCatalogue") {
          this.addItem = false;
          this.addCatalogue = true;
          (this.generalModalTrigger.nativeElement as HTMLButtonElement).click();
          this.mockstore.viewCatalagueMode = false;
          this.mockstore.editCatalogueMode = false;
        }

        if (
          val instanceof CommunicationCommand &&
          val.action == "edit" &&
          val.component == "catalogue"
        ) {
          this.addItem = false;
          this.addCatalogue = true;
          this.catalogueInput = { mode: val.action, payload: val.message };
          this.mockstore.viewCatalagueMode = false;
          (this.generalModalTrigger.nativeElement as HTMLButtonElement).click();
        }

        if (
          val instanceof CommunicationCommand &&
          val.action == "view" &&
          val.component == "catalogue"
        ) {
          this.addItem = false;
          this.addCatalogue = true;
          this.mockstore.editCatalogueMode = false;
          this.viewCatalogueInput = { mode: val.action, payload: val.message };
          (this.generalModalTrigger.nativeElement as HTMLButtonElement).click();
        }
      }
    );
    // opens the itemsSelectionView
    this.destroySubscriptions[2] = this.generalservice.addItemsFromCatalogueListing$.subscribe(
      val => {
        if (val.length < 1) return;
        if (val["switcher"] == "open") {
          this.componentToDisplay = val["message"];
          this.slideOut = true;
        } else {
          this.componentToDisplay = "";
          this.slideOut = false;
        }
      }
    );

    document
      .querySelector(".zoomContainer")
      .addEventListener("mousemove", e => {
        e.stopPropagation;
        e.stopImmediatePropagation;
      });
  }

  // closes the slider
  closeSlider(event?: MerchantItems) {
    this.slideOut = false;
    // if this event is a MerchantItem, then the edit button as been clicked
    // this function will now send the merchantItem to the add Item to be edited;
    if (event && event["id"]) {
      (this.generalModalTrigger.nativeElement as HTMLButtonElement).click();
      this.itemToEdit = event;
      this.addItem = true;
    }
    this.componentToDisplay = "";
  }

  async closeOrOpenModal(event?: any) {
    if (event && event instanceof CommunicationCommand) {
      // console.log(event);
      this.componentToDisplay = event.component;
      // console.log(this.componentToDisplay);
    }

    if (
      event &&
      event instanceof CommunicationCommand &&
      event.component.includes("catalogue")
    ) {
      // since we are coming from items selection, re open the catalogue
      // fetch from localforage all selected Pictures
      this.addCatalogue = true;
      // console.log(event);
      try {
        const res = await localForage.getItem("selectedPictures");
        this.itemsSelectedFromSelectionComponent = res;
      } catch (error) {
        console.log(error);
      }
    }
    (this.generalModalTrigger.nativeElement as HTMLButtonElement).click();
    this.mockstore.editCatalogueMode = false;
    this.mockstore.viewCatalagueMode = false;
  }

  // async FetchTokenAndSaveQuickly() {
  //   const token = toke;
  // }

  ngOnDestroy() {
    // this function will fire once  the component has been destroyed
    this.destroySubscriptions.forEach(element => {
      if (element instanceof Subscription) element.unsubscribe();
    });
  }
}
